import { LockKeyhole } from 'lucide-react';
import React from 'react';
import { YStack, Text, Button } from 'tamagui';

interface UnlockButtonProps {
  text: string;
  onUnlock: () => void;
}

export const UnlockButton: React.FC<UnlockButtonProps> = ({ text, onUnlock }) => {
  const onUnlockClick = () => {
    if (onUnlock) {
      onUnlock();
    }
  };

  return (
    <Button
      onPress={onUnlockClick}
      unstyled
      cursor="pointer"
      pressStyle={{
        transform: [{ scale: 0.95 }],
      }}>
      <YStack alignItems="center" gap="$4">
        <LockKeyhole size={48} />
        <Text fontFamily="$body" fontSize="$9" fontWeight="$4" textAlign="center">
          {text}
        </Text>
      </YStack>
    </Button>
  );
};
